import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { ChangeLanguageService } from 'src/app/services/change-language.service';
import { CustomerInfoDataService } from 'src/app/services/customer-info-data.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-customer-approve',
  templateUrl: './customer-approve.component.html',
  styleUrls: ['./customer-approve.component.scss']
})
export class CustomerApproveComponent implements OnInit {

  uuid1: string;
  uuid2: string;
  lang: string;
  loading: boolean = true;
  isApprove: boolean = false;
  personsData: any;
  availablePersons: any[] = [];
  selectedPersonToAdd: any;
  targetDepartmentPersons: any[] = [];
  displayAddDialog: boolean = false;

  constructor(private customerInfoDataService: CustomerInfoDataService, private route: ActivatedRoute, private languageService: ChangeLanguageService,private userService: UserService, private translation: TranslateService,  private messageService: MessageService, private confirmService: ConfirmationService) {

  }

  async ngOnInit()  {
    this.uuid1 = this.route.snapshot.paramMap.get('uuid1') || '';
    this.uuid2 = this.route.snapshot.paramMap.get('uuid2') || '';
    this.lang = this.route.snapshot.paramMap.get('lang') || 'tr';

    
    
    this.route.paramMap.subscribe(params => {
      this.uuid1 = params.get('uuid1') || '';
      this.uuid2 = params.get('uuid2') || '';
      this.lang = params.get('lang') || 'tr';
    });

    this.translation.use(this.lang);

      this.translation.use(this.lang);
      localStorage.setItem('lang', "en");
      localStorage.setItem('locale', "en");
      this.languageService.languageChanged.next(this.lang);


  
    

    if(this.uuid1 && this.uuid2) {
      try {
        this.personsData =  await this.customerInfoDataService.getCustomerInfoData(this.uuid1, this.uuid2).toPromise();
      } catch(e) {
        this.messageService.add({severity: 'warn',  key: 'html-msg', summary: 'Uyarı', detail: e.error.message });
      } finally {
        this.loading=false;
      }

    }

    
  }

  editPerson(person: any) {
      person['onEdit'] = !person['onEdit'];
  }

  async savePerson(person: any) {
    const approveCustomerAddPersonInvalidMessage = await this.translation.get('approveCustomerAddPersonInvalidMessage').toPromise();
    const alreadyExistsMessage = await this.translation.get('alreadyExistsUseAddToDepartment' as any).toPromise();
  
    if (!this.validatePerson(person)) {
      this.messageService.add({
        severity: 'warn',
        key: 'html-msg',
        summary: 'Uyarı',
        detail: approveCustomerAddPersonInvalidMessage
      });
      return;
    }

    const personName = person.fullname?.trim();
    if (!personName) return;
    console.log(personName)
    console.log(person)
    if (person.type === 'added') {
      const duplicate = this.personsData?.persons
        .flatMap(dep => dep.person)
        .find(p => p.fullname?.trim() === personName && p !== person);
  
      if (duplicate) {
        this.messageService.add({
          severity: 'warn',
          key: 'html-msg',
          summary: 'Uyarı',
          detail: alreadyExistsMessage || 'Bu kişi başka bir departmanda zaten var. Lütfen bu kişiyi eklemek için "Departmana Ekle" butonunu kullanın.'
        });
        return;
      }
  
      person.onEdit = false;
      return;
    }
  
    if (person.onEdit) {
      const updatedFields = {
        tel: person.tel,
        gsm: person.gsm,
        email: person.email,
        title: person.title
      };
  
      console.log(updatedFields)
      this.personsData?.persons.forEach(dep => {
        dep.person.forEach(p => {
          if (p.fullname === personName) {
            Object.assign(p, updatedFields);
   
            if (p.type !== 'added') {
              p.type = 'edited';
            }
            p.onEdit = false;
          }
        });
      });
    }
  }
  

  addPerson(persons: any) {
    persons.push({'gsm': null, "tel": null, "fullname": null, title: null, "email": null, "onEdit": true, "type": "added"})
  }

  addPersonToDepartment(currentDepartmentPersons: any[]) {
    const allPersons = this.personsData?.persons
      .flatMap(dep => dep.person)
      .filter(p => !['quitJob', 'quitDepartment'].includes(p.type));
  
    const currentNames = new Set(currentDepartmentPersons.map(p => p.fullname));
  
    const nameMap = new Map<string, any>();
    allPersons.forEach(p => {
      const name = p.fullname;
      if (name && !nameMap.has(name) && !currentNames.has(name)) {
        nameMap.set(name, p);
      }
    });
  
    this.availablePersons = Array.from(nameMap.values());
    this.targetDepartmentPersons = currentDepartmentPersons;
    this.selectedPersonToAdd = null;
    this.displayAddDialog = true;
  }
  
  confirmAddPersonToDepartment() {
    if (this.selectedPersonToAdd && this.targetDepartmentPersons) {
      const newPerson = { ...this.selectedPersonToAdd };
      newPerson.type = 'addToDepartment';
      newPerson.onEdit = false;
      this.targetDepartmentPersons.push(newPerson);
    }
    this.displayAddDialog = false;
  }
  
  async deletePerson(index: number, persons: any[]) {
      const removePersonConfirmMessage = await this.translation.get('removePersonConfirmMessage').toPromise();

      if(!persons[index].id) {
         persons.splice(index,1);
        
      } else {
        this.confirmService.confirm({
            key: 'confirmDelPerson',
            message: removePersonConfirmMessage,
            accept: () => {
                persons[index]['type'] = 'quitJob'
            },
            reject: (type) => {
              if (type === ConfirmEventType.REJECT) {
                  persons[index]['type'] = 'quitDepartment';
              }
            }
        });
      }
  }

  async onApprove() {
    let isValid = true;
    this.personsData['persons'].forEach(f => {
      f.person.forEach(person => {
        if((person?.onEdit || person?.type == 'added') && !this.validatePerson(person)) {
          isValid = false;
          console.log(person)
        }
      })
    })

    if(!isValid) {
      const formInvalid = await this.translation.get('formInvalid').toPromise();
      this.messageService.add({severity: 'warn', key: 'html-msg', summary: 'Uyarı', detail: formInvalid });
      return;
    }

    if(!this.isApprove || this.loading) return


    try {
      this.loading = true;
      await this.customerInfoDataService.postCustomerInfoData(this.uuid1, this.uuid2, this.personsData).toPromise();
      const successUpdate = await this.translation.get('successUpdate').toPromise();
      this.messageService.add({severity: 'success',  key: 'html-msg', summary: 'Uyarı', detail: successUpdate });
    } catch(e) {
      const runtimeException = await this.translation.get('runtimeException').toPromise();
      this.messageService.add({severity: 'warn',  key: 'html-msg', summary: 'Uyarı', detail: runtimeException });
    } finally {
      this.loading = false;
    }
    
  }

  validatePerson(person: any): boolean {
    const requiredFields = ['fullname', 'tel', 'gsm', 'email', 'title'];
  
    for (let field of requiredFields) {
      if (!person[field] || !person[field].toString().trim()) {
        console.log('Eksik alan:', field);
        return false;
      }
    }
  
    return true;
  }
}
